export const PAYABLES = 'payables'
export const EXPECTED = 'expected'
export const PAID = 'paid'

export const PENDING = 'pending'
export const APPROVED = 'approved'
export const REPROVED = 'reproved'
export const DELETED_BY_REQUESTOR = 'deleted_by_requestor'